import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../icon';
import stopIcon from '../icon/icons-stop.icon';
import playIcon from '../icon/icons-play.icon';

import './live-player.scss';

function isSafariVersion(versionNumber) {
    const userAgentLowerCase = navigator.userAgent.toLowerCase();
    return (userAgentLowerCase.indexOf('safari') >= 0) && (userAgentLowerCase.indexOf(`version/${versionNumber}`) >= 0);
}

class LivePlayer extends React.Component {
    constructor(props) {
        super(props);

        this._togglePlay = this._togglePlay.bind(this);

        this.state = {
            isPlaying: false,
            liveBroadcast: null,
        };
    }

    componentDidMount() {
        const that = this;
        function setCurrentTime() {
            const nowTime = new Date();
            const durationMs = parseInt(that.audioElement.duration * 1000);
            const startAtMs = (nowTime.valueOf() - that.state.liveBroadcast.startMoment.valueOf()) % durationMs;
            that.audioElement.currentTime = parseInt(startAtMs / 1000);
            if (that.state.isPlaying) that.audioElement.play();
        }

        // Assign the audioelement first, before initiating state changes.
        this.audioElement = document.getElementById('nts-player-audio');
        this.audioElement.addEventListener('play', () => {
            this.setState({
                isPlaying: true,
            });
        }, false);
        this.audioElement.addEventListener('playing', () => {
            this.setState({
                isPlaying: true,
            });
        }, false);
        this.audioElement.addEventListener('loadedmetadata', () => {
            if (isSafariVersion("11.0")) {
                return setTimeout(setCurrentTime, 50);
            }
            setCurrentTime();
        }, false);

        const liveBroadcast = this.props.sessionBroadcastManager.getLiveBroadcast();

        this.setState({
            liveBroadcast,
        });

        this.props.sessionBroadcastManager.onLiveBroadcastChange((newLiveBroadcast) => {
            this.setState({
                liveBroadcast: newLiveBroadcast,
            });
        });
    }

    componentDidUpdate() {
        if (this.state.isPlaying && this.state.liveBroadcast.source && (this.audioElement.src !== this.state.liveBroadcast.source)) {
            this.audioElement.src = this.state.liveBroadcast.source;
            this.audioElement.load();
        }
    }

    _stopStream() {
        this.audioElement.pause();

        this.setState({
            isPlaying: false,
        });
        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', 'Audio', 'Stop');
    }

    _playStream() {
        this.audioElement.src = this.state.liveBroadcast.source;
        this.audioElement.load();
        this.audioElement.play(); // required for firefox.
        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', 'Audio', 'Play');
    }

    _togglePlay() {
        if (this.state.isPlaying) {
            this._stopStream();
        } else {
            this._playStream();
        }
    }

    render() {
        const liveBroadcast = this.props.sessionBroadcastManager.getLiveBroadcast();
        const broadcast = liveBroadcast || this.props.sessionBroadcastManager.broadcasts[0];

        const actionBtnType = !!this.state.isPlaying ? 'action-btn--stop' : 'action-btn--play';
        const actionBtnIcon = !!this.state.isPlaying ? stopIcon : playIcon;

        return (
            <div id="live-player-container">
                <div className="live-player">
                    <div className="live-player__text">
                        <span className="text-bold">Autechre. </span>{broadcast.name}.
                    </div>

                    {!!liveBroadcast ? (
                        <div className="live-player__button" onClick={this._togglePlay}>
                            <span className="live-player__button__text">Listen now</span>
                            <button className={`live-player__button__icon action-btn ${actionBtnType}`}>
                                <Icon icon={actionBtnIcon} />
                            </button>
                        </div>
                    ) : (
                        <div className="live-player__button live-player__button--large" >
                            <span className="live-player__button__text">
                                Live on <br className="hidden-desktop"/>
                            </span>
                            {broadcast.broadcastStartDate}, {broadcast.broadcastStartTimeShort}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

LivePlayer.propTypes = {
    sessionBroadcastManager: PropTypes.object.isRequired,
};

export default LivePlayer;



// WEBPACK FOOTER //
// ./src/components/LivePlayer/index.jsx